<div [class]="'s__stat' + (align() === 'center' ? ' s__stat--center' : '')">
  <span class="s__stat__value">{{ value() }}</span>
  <span class="s__stat__label">{{ label() }}</span>
  @if (context()) {
    <span class="s__stat__context">{{ context() }}</span>
  }
</div>
